import * as React from 'react';
import { Col, Row } from 'antd';
import { observer } from 'mobx-react';

import { BooleanView } from 'src/core/ui/boolean.view';
import { TextView } from 'src/core/ui/text.view';
import { TabLanguageController } from 'src/core/ui/language/tab-language.controller';
import { PolicyRuleDataService } from 'src/app/bookings/policy-rules/policy-rule-form.data';
import { GenericPolicyFormView } from 'src/app/bookings/policies/generic-policy-form.view';
import { Prompt } from 'react-router';
import { ContextService } from 'src/core/services/context.service';

interface Props extends ComponentViewProps<PolicyItem> {
	title: string,
	save: () => Promise<void>;
	cancel: () => void;
	mode: ControlMode;
	onModeChange: (mode: ControlMode) => void;
	policyRuleDataService: PolicyRuleDataService;
	breadcrumb: any[];
	goToCard: (text: any, key: string, model: PolicyRuleItem) => void;
	contextService: ContextService;
}

@observer
export class PolicyFormView extends React.Component<Props, {}> {
	render(): React.ReactNode {
		const { model, mode, setBusy, contextService } = this.props;
		const translations = (model as any).dynamicProperties['displayName'];
		const array: TabLanguageModel[] = [
			{
				title: 'Name',
				dynamicProperties: translations,
				rows: 2
			}
		];

		return (
			<React.Fragment>
				<Prompt
					when={contextService.isDirty}
					message={location => `If you go to ${location.pathname}, all changes will be lost. Are you sure you want to continue?`}
				/>
				<GenericPolicyFormView
					rulesSections={['general', 'product']}
					policyRuleOwner={{
						policyId: model.id,
						policy: model
					}}
					{...this.props}
				>
					<Row>
						<Col xs={24}>
							<TabLanguageController
								model={model}
								dynamicProperties={array}
								mode={mode}
								setBusy={setBusy}
								isRichTextBox={false}
							/>
						</Col>
						<Col xs={24}>
							<TextView
								required
								label="Commission"
								value={model.commission}
								onChanged={(newVal) => {
									model.commission = newVal != null ? parseFloat(newVal) : null;
								}}
								validate={value => value === '' || (/^\d+([.]\d*)?$/.test(value) && parseFloat(value) <= 100)}
								mode={mode}
								onGetErrorMessage={() => model.validate(false, 'commission')}
								format="percent"
								suffix="%"
							/>
						</Col>
						<Col xs={24}>
							<BooleanView
								label="Active"
								value={model.isActive}
								onChanged={(newVal) => {
									model.isActive = newVal;
								}}
								mode={mode}
							/>
						</Col>
					</Row>
				</GenericPolicyFormView>
			</React.Fragment>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/bookings/policies/form/policy-form.view.tsx